import { Languages, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useT } from "@/i18n/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useT();
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="h-10 inline-flex items-center gap-1.5 px-3 rounded-full hover:bg-stone-100 dark:hover:bg-stone-800 text-sm font-medium"
          data-testid="lang-switcher-btn"
          aria-label="Language"
        >
          <Languages className="h-4 w-4" />
          <span className="hidden sm:inline">{current.flag}</span>
          <span className="hidden md:inline uppercase font-mono-xs">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className="cursor-pointer"
            data-testid={`lang-option-${l.code}`}
          >
            <span className="mr-2">{l.flag}</span>
            <span className="flex-1">{l.name}</span>
            {l.code === lang && <Check className="h-4 w-4 text-amber-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
